import React, { useEffect, useMemo, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { ReadCookie } from "../../utils/readCookie";
import { useLocation } from "react-router-dom";
import Loader from "react-loader-spinner";
import "./CustomerPaymentPrint.css";
import { Button } from "antd";
import CustomerPaymentPrintHeader from "./CustomerPaymentPrintHeader/CustomerPaymentPrintHeader";
import { getCustomerPaymentPrint } from "../../redux/actions/customerPaymentPrint.action";
import { getOneCustomerPaymentLine } from "../../redux/actions/customerPaymentLine.action";
import { TabTitle } from "../../utils/GeneralFunction";
import moment from "moment";
import numeral from "numeral";


const CustomerPaymentPrint = () => {
  TabTitle("Customer Payment Print")
  const dispatch = useDispatch();
  const menuId = ReadCookie("menuId");
  const token = ReadCookie("token");
  const { customerPaymentPrint } = useSelector((state) => state);

  const [data, setData] = useState([]);

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }



  let query = useQuery();

  let payment_header_id = query.get("payment_header_id");

  const headerData =
    customerPaymentPrint && customerPaymentPrint?.payload?.data[0];

  const values = {
    payment_header_id: payment_header_id,
  };


  useEffect(() => {
    dispatch(getCustomerPaymentPrint(token, values));
    dispatch(getOneCustomerPaymentLine(token, payment_header_id)).then((res) => {
      if (res.type === "GET_ONE_PAY_CUSTOMER_PAYMENT_LINE_SUCCESS") {
        setData(res.payload.data);
      }
    });
  }, [payment_header_id]);



  const handlePrint = () => {
    const css = '@page { size: landscape; margin: 20px;}';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style); // Clean up after print
  };


  const totalAmountPaid = data
    ?.reduce((sum, item) => sum + (Number(item.amount_paid) || 0), 0);

  return (
    <div>
      {customerPaymentPrint?.loading ?
        <div className='loaderDiv' >
          <Loader
            type="Grid"
            color="#212121"
            height={40}
            width={40}
          />
        </div> :
        <div
          className="sales_report_view"
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <table>
            <thead>
              <tr>
                <td className="new-sales-report-footer">
                  <div>
                    <CustomerPaymentPrintHeader />
                  </div>
                </td>
              </tr>
            </thead>
            {!customerPaymentPrint.loading && (
              <div className="no-print" style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px', marginRight: "114px" }}>
                <Button type="primary" onClick={handlePrint}>
                  Print
                </Button>
              </div>
            )}
            <tbody>
              <tr>
                <td>
                  <div className="content-block">
                    <div className="sales-report-Table-data">

                      <table className="sales-report-table" >
                        <tbody>
                          <tr>
                            <td
                              className="font_weight"
                              style={{
                                width: "36px",
                              }}
                            >
                              S.No
                            </td>
                            {/* <td
                              className="font_weight"
                              style={{
                                width: "140px",
                              }}
                            >
                              Invoice Header ID
                            </td> */}
                            <td
                              className="font_weight"
                              style={{
                                width: "140px",
                              }}
                            >
                              Transaction Type

                            </td>


                            <td
                              className="font_weight"
                              style={{
                                width: "140px",
                              }}
                            >
                              Transaction No
                            </td>
                            <td
                              className="font_weight"
                              style={{
                                width: "140px",
                              }}
                            >
                              Transaction Date
                            </td>



                            <td
                              className="font_weight"
                              style={{
                                width: "140px",
                              }}
                            >
                              Payment Term
                            </td>
                            <td
                              className="font_weight"
                              style={{
                                width: "80px",
                              }}
                            >
                              Gender
                            </td>
                            <td
                              className="font_weight"
                              style={{
                                width: "150px",
                              }}
                            >
                              PO#
                            </td>
                            <td
                              className="font_weight"
                              style={{
                                width: "150px",
                              }}
                            >
                              EDI#
                            </td>
                            <td
                              className="font_weight px-2"
                              style={{
                                width: "140px",
                                textAlign: 'right'
                              }}
                            >
                              Discount Taken
                            </td>
                            <td
                              className="font_weight px-2"
                              style={{
                                width: "80px",
                                textAlign: 'right',

                              }}
                            >
                              Payment
                            </td>
                          </tr>

                          {data?.map((it, index) => {
                            return (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                {/* <td
                                  style={{
                                    marginLeft: "0",
                                  }}
                                >
                                  {it.invoice_header_id}
                                </td> */}
                                <td>
                                  {it.transaction_type}
                                </td>
                                <td className="text-left px-1">
                                  {it.invoice_header_no}
                                </td>
                                <td className="text-left px-1">
                                  {moment(it.invoice_date).format("MM-DD-YYYY")}
                                </td>


                                <td className="text-left px-1">
                                  {it.term_name}
                                </td>
                                <td className="text-left px-1">
                                  {it.gender_name}
                                </td>
                                <td className="text-left px-1">
                                  {it.reference_no}
                                </td>
                                <td className="text-left px-1">
                                  {it.edi}
                                </td>
                                <td className="text-right px-2">
                                  $ {numeral(it.discount_taken).format("0.00")}
                                </td>

                                <td className="text-right px-2">
                                  $ {numeral(it.amount_paid).format("0.00")}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      {/* );
                      })} */}




                    </div>
                  </div>
                  <table className="customer-payment-report-table-total">
                    <tbody>
                      <tr className="font_weight">
                        <td
                          style={{
                            width: "70px",
                            textAlign: "right",
                            paddingRight: "10px",
                          }}
                          className="font_weight total_cell"
                        >
                          Payment Amount
                        </td>

                        
                        <td
                          className="total_amount"
                          style={{
                            width: "65px",
                            textAlign: "right",
                            paddingRight: "10px",
                          }}
                        >
                          $ {numeral(headerData && headerData.payment_amount).format("0.00")}
                        </td>
                      </tr>

                      <tr>
                        <td
                          className="font_weight"
                          style={{
                            width: "100px",
                            textAlign: "right",
                            paddingRight: "10px",
                          }}
                        >
                          Applied Amount
                        </td>
                        <td
                        style={{
                          width: "30px",
                          textAlign: "right",
                          paddingRight: "10px",
                        }}
                        >$ {numeral(totalAmountPaid).format("0.00")}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      }

    </div>
  );
};





export default CustomerPaymentPrint;